<template>
    <div class="mobile-overflow-menu">
        <v-menu offset-y left :eager="true">
            <template #activator="{ on, attrs }">
                <v-btn icon
                       small
                       v-bind="attrs"
                       v-on="on"
                       class="overflow-menu-btn"
                >
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>

            <v-list dense>
                <!-- Theme Toggle -->
                <v-list-item @click.stop="toggleDarkTheme">
                    <v-list-item-icon>
                        <v-icon small v-if="theme === 'light'">mdi-white-balance-sunny</v-icon>
                        <v-icon small v-else-if="theme === 'dark'">mdi-weather-night</v-icon>
                        <v-icon small v-else>mdi-theme-light-dark</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            <span v-if="theme === 'light'" class="font-weight-bold">Light Theme</span>
                            <span v-else-if="theme === 'dark'" class="font-weight-bold">Dark Theme</span>
                            <span v-else>System Theme</span>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Debug Mode (if applicable) -->
                <template v-if="canShowDebugMode">
                    <v-divider />

                    <v-list-item @click="switchEnvironment">
                        <v-list-item-icon>
                            <v-icon small>mdi-home-switch</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Switch Environment</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="toggleDebugMode">
                        <v-list-item-icon>
                            <v-icon small :color="debugMode ? 'red' : undefined">mdi-test-tube</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                <span v-if="debugMode">Disable Debug Mode</span>
                                <span v-else>Enable Debug Mode</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <!-- Host a Meet Button -->
                <template v-if="user">
                    <v-divider />

                    <v-list-item
                        :href="user && !trimmedToolbar ? $route('meets.create') : $route('interest.index')"
                        @click.prevent="
                            $inertia.visit(user && !trimmedToolbar ? $route('meets.create') : $route('interest.index'))
                        "
                    >
                        <v-list-item-icon>
                            <v-icon small>mdi-calendar-plus</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Host a Meet</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <!-- Additional Actions Slot -->
                <slot></slot>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'MobileOverflowMenu',

    props: {
        theme: {
            type: String,
            required: true,
            default: 'system',
        },
        canShowDebugMode: {
            type: Boolean,
            default: false,
        },
        debugMode: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Object,
            default: null,
        },
        trimmedToolbar: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['toggle-theme', 'switch-environment', 'toggle-debug-mode'],

    validations: {
        theme: {
            required: true,
            validator: value => ['light', 'dark', 'system'].includes(value),
        },
    },

    methods: {
        toggleDarkTheme() {
            this.$emit('toggle-theme');
        },
        switchEnvironment() {
            this.$emit('switch-environment');
        },
        toggleDebugMode() {
            this.$emit('toggle-debug-mode', !this.debugMode);
        },
    },
};
</script>

<style scoped>
.mobile-overflow-menu {
    display: inline-flex;
    align-items: center;
}

.overflow-menu-btn {
    opacity: 0.85;
    transition: opacity 0.2s ease;
}

.overflow-menu-btn:hover {
    opacity: 1;
}
</style>
